import { render, staticRenderFns } from "./ProfileWizard.vue?vue&type=template&id=31c4ffca"
import script from "./ProfileWizard.vue?vue&type=script&lang=js"
export * from "./ProfileWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports